(function (module) {
    'use strict';

    function BlockedUserConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('blocked-user', {
                url: '/blocked-user',
                data: {
                    pageTitle: 'BLOCKED_ACCOUNT.PAGE_TITLE'
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl'
                    },
                    'content@blocked-user': {
                        templateUrl: '/js/authentication/blocked-user/blocked-user.html',
                        controller: 'BlockedUserCtrl as $ctrl'
                    }

                },
                resolve: {
                    currentUser: function (User) {
                        return User.getCurrent().$promise.then(function (response) {
                            return response;
                        });
                    },
                    account: function (currentUser, Account, $state) {
                        const accountId = currentUser.accountId;
                        Account.findById({ id: accountId })
                            .$promise
                            .then(function (account) {
                                if (account.enabled && account.accountVerified) {
                                    $state.go('root.home');
                                }
                                if (account.enabled && !account.accountVerified) {
                                    $state.go('unverified-account');
                                }
                            });

                    }
                },
                bodyClass: 'page--blocked-user'
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/blocked-user');

    }

    function BlockedUserCtrl(Store, LoopBackAuth, $state) {
        this.clearCookies = () => {
            Store.setCurrentSubAccountId(null);

            LoopBackAuth.clearUser();
            LoopBackAuth.clearStorage();
            $state.go('login');

        };

    }

    module
        .config(BlockedUserConfig)
        .controller('BlockedUserCtrl', BlockedUserCtrl);

})
(angular.module('rocket.components'));
